/**
 * Route for `kpi-threshold-triggers-cr-drop-epc-drop-fraud-spike-payout-b`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { KpiThresholdTriggersCrDropEpcDropFraudSpikePayoutBPage } from "../features/kpi-threshold-triggers-cr-drop-epc-drop-fraud-spike-payout-b/KpiThresholdTriggersCrDropEpcDropFraudSpikePayoutBPage";

export const kpiThresholdTriggersCrDropEpcDropFraudSpikePayoutBRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/kpi-threshold-triggers-cr-drop-epc-drop-fraud-spike-payout-b",
	component: KpiThresholdTriggersCrDropEpcDropFraudSpikePayoutBPage,
});

export default kpiThresholdTriggersCrDropEpcDropFraudSpikePayoutBRoute;
